import { render, staticRenderFns } from "./Iconos.vue?vue&type=template&id=50b50a16&lang=pug"
import script from "./Iconos.vue?vue&type=script&lang=js"
export * from "./Iconos.vue?vue&type=script&lang=js"
import style0 from "./Iconos.vue?vue&type=style&index=0&id=50b50a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports